import { msg } from 'gt-react';
import type { SupplierReferenceRank } from '@erp/rpc';

type ReferenceStrategy = SupplierReferenceRank['strategy'];
type ReferenceOrigin = SupplierReferenceRank['origin'];

/**
 * Where a supplier writes our VDM numbers (#7650) — one reference
 * configuration each. A record over the whole vocabulary, so a new strategy
 * without a name is a type error. Decode with `useMessages()`.
 */
export const REFERENCE_STRATEGY_LABELS: Record<ReferenceStrategy, string> = {
  subject_token: msg('ADM/VDM number in the subject', {
    context: '849 reference configuration: "ADM35067" or "VDM No 13694"',
  }),
  prose_debit_memo: msg('"Debit Memo No" in the subject', {
    context:
      '849 reference configuration: "Vendor Debit Memo No 13625" written out',
  }),
  reference_cluster: msg('VDM in a batch-code run in the subject', {
    context: '849 reference configuration: "16105_CO30218-CO30263"',
  }),
  bare_debit_memo: msg('Bare "DM" number in the subject', {
    context:
      '849 reference configuration: "DM 18314", our VDM without its A or V',
  }),
  batch_range: msg('844 batch codes in the subject', {
    context:
      '849 reference configuration: "CT30414" or "CE30399-CE30411", our batch codes naming the claims',
  }),
  row_value: msg('Debit-memo column of the report', {
    context:
      '849 reference configuration: the report column mapped as the debit memo number',
  }),
};

export const REFERENCE_ORIGIN_LABELS: Record<ReferenceOrigin, string> = {
  default: msg('Every supplier', {
    context: '849 reference configuration origin: held by every supplier',
  }),
  migrated: msg('From the old settings', {
    context:
      '849 reference configuration origin: migrated from the per-supplier flag',
  }),
  correction: msg("Taught by a reviewer's claim link", {
    context:
      '849 reference configuration origin: proposed when a reviewer linked a claim',
  }),
};
